import axios from 'axios';
import { env } from '../../config/env';

const configuredBase = String(env.API_ENDPOINT_URL || '').replace(/\/+$/, '');
const endpoint = /\/careadmin\/maintenance\/mgmt$/i.test(configuredBase)
  ? configuredBase
  : `${configuredBase}/careadmin/maintenance/mgmt`;

const client = axios.create({
  baseURL: endpoint,
  headers: env.API_ENDPOINT_KEY ? { 'x-api-key': env.API_ENDPOINT_KEY } : {}
});

const query = (func, values = {}) => {
  const params = new URLSearchParams({ func });
  Object.entries(values).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') params.set(key, String(value));
  });
  return `?${params.toString()}`;
};

const tokenHeaders = token => ({ 'X-Maintenance-Access-Token': token });
const data = response => response.data?.data ?? response.data;

export const maintenanceExternalError = (error, fallback = 'The maintenance service could not complete this request.') => (
  error?.response?.data?.error || error?.response?.data?.message || error?.message || fallback
);

export async function validateMaintenanceAccess(token, signal) {
  return data(await client.post(query('ExternalMaintenanceAccessValidate'), undefined, {
    headers: tokenHeaders(token), signal
  }));
}
export async function getExternalMaintenanceTasks(token, values, signal) {
  return data(await client.get(query('ExternalMaintenanceTaskList', values), {
    headers: tokenHeaders(token), signal
  }));
}

export async function getExternalMaintenanceTask(token, centreId, issueId, signal) {
  return data(await client.get(query('ExternalMaintenanceTaskGet', { centre_id: centreId, id: issueId }), {
    headers: tokenHeaders(token), signal
  }));
}

export async function getExternalMaintenanceStaff(token, centreId, signal) {
  return data(await client.get(query('ExternalMaintenanceStaffList', { centre_id: centreId }), {
    headers: tokenHeaders(token), signal
  }));
}

export async function assignExternalMaintenanceTask(token, centreId, issueId, assigneeId) {
  return data(await client.put(query('ExternalMaintenanceTaskAssign', { centre_id: centreId, id: issueId }),
    { payload: { assigned_to: assigneeId } }, { headers: tokenHeaders(token) }));
}

export async function getExternalMaintenanceMessages(token, centreId, issueId, signal) {
  return data(await client.get(query('ExternalMaintenanceMessagesList', { centre_id: centreId, id: issueId }), {
    headers: tokenHeaders(token), signal
  }));
}

export async function createExternalMaintenanceMessage(token, centreId, issueId, payload) {
  return data(await client.post(query('ExternalMaintenanceMessageCreate', { centre_id: centreId, id: issueId }),
    { payload }, { headers: tokenHeaders(token) }));
}

export async function updateExternalMaintenanceStatus(token, centreId, issueId, nextStatus) {
  return data(await client.put(query('ExternalMaintenanceStatusUpdate', { centre_id: centreId, id: issueId }),
    { payload: { status: nextStatus } }, { headers: tokenHeaders(token) }));
}
